import { ajaxFunc } from '../tools';

const lianlian = {
  // 获取连连钱包的状态信息
  fetchAgentAccount: ajaxFunc('/agent/account_agent', 'get')
};

export default lianlian;



// WEBPACK FOOTER //
// ./src/request/api/lianlian.js